import React from 'react';
import { FormHelperText } from '@material-ui/core';

const TreeError = ({ listSide, formRenderProps }) => {
  if (formRenderProps) {
    const { errors, modified, submitFailed } = formRenderProps;
    if (
      listSide === 'right' &&
      ((errors &&
        modified &&
        (modified.fundIds || modified.fundInvestorTagId)) ||
        submitFailed)
    ) {
      return <FormHelperText error>{errors && errors.required}</FormHelperText>;
    } else {
      return null;
    }
  }

  return null;
};

export default TreeError;
